import { useParams } from 'react-router-dom';
import LivingAnnouncementCategory from './LivingAnnouncementCategory';
import { CATEGORIES, type CategorySlug } from '@/data/livingAnnouncementExamples';
import NotFound from '@/pages/NotFound';

export default function LivingAnnouncementCategoryRoute() {
  const { slug } = useParams<{ slug: string }>();
  const cat = slug && (CATEGORIES as Record<string, (typeof CATEGORIES)[CategorySlug]>)[slug];
  if (!cat) return <NotFound />;
  return <LivingAnnouncementCategory category={cat} />;
}
